import { RootState } from "@/shared/types";
import { INonInventoryData, IGetManyNonInventoryParams } from "./types/interfaces";

export const selectManyNonInventory = (state: RootState): INonInventoryData =>
  state.nonInventory.data;

export const selectParams = (state: RootState): IGetManyNonInventoryParams =>
  state.nonInventory.params;
